import React, { useState } from "react";
import {
  colorBlack,
  colorDarkRed,
  colorWhite,
  primaryColor,
} from "../../../utility/constants/colorManager";
import "../../../index.css";
import { CustomButton } from "../main_comps/custom_button";
function RejectReasonModal({
  onClickBack,
  onClickOK,
  title,
  reason = "Rejecting",
  button1 = "Cancel",
  button2 = "Reject",
  buttonColor1 = colorWhite,
  buttonColor2 = colorDarkRed,
  loading = false,
}) {
  const [description, setDescription] = useState("");
  return (
    <div
      style={{
        width: "100%",
        padding: "0px 15px",
      }}
    >
      <p
        style={{
          color: primaryColor,
          fontWeight: "500",
        }}
      >
        {title
          ? title
          : " Do you want to reject the client?, if so provide the reason."}
      </p>

      <div
        style={{
          border: "1px solid rgba(231, 66, 66, 0.25)",
          minHeight: 150,
          borderRadius: 3,
          marginTop: 20,
          position: "relative",
        }}
      >
        <div
          style={{
            border: "1px solid #E74242",
            backgroundColor: "#F9F9FB",
            padding: "10px 15px",
            borderRadius: 5,
            position: "absolute",
            top: -5,
            width: "100%",
          }}
        >
          <p
            style={{
              color: "#E74242",
              fontWeight: "600",
            }}
          >
            Reason for {reason}
          </p>
        </div>
        <div
          style={{
            marginTop: 40,
          }}
        >
          <textarea
            type="textarea"
            style={{
              width: "100%",
              border: "none",
              outline: "none",
              paddingLeft: 20,
              paddingTop: 10,
              minHeight: 30,
            }}
            multiple={true}
            className="textarea1"
            onChange={(val) => {
              // if (/^[\w\-\s]+$/.test(val)) {
              //   setDescription(val.target.value);
              // } else if (description.length === 1) {
              //   setDescription("");
              // }

              if (/^[a-zA-Z0-9 ]+$/.test(val.target.value)) {
                setDescription(val.target.value);
              } else if (description.length === 1) {
                setDescription("");
              }
            }}
            validator="alphaNumeric"
            value={description}
            disabled={false}
            placeholder="type here"
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: 20,
          justifyContent: "center",
          marginTop: 30,
        }}
      >
        <CustomButton
          title={button1}
          styles={{
            backgroundColor: buttonColor1,
            border: "1px solid black",
            padding: 0,
            height: "auto",
            padding: "13px 10px",
          }}
          textStyles={{
            color: colorBlack,
          }}
          onClick={onClickBack}
        />{" "}
        <CustomButton
          title={button2}
          styles={{
            backgroundColor: buttonColor2,
            border: "none",
            padding: 0,
            height: "auto",
            padding: "15px 40px",
          }}
          textStyles={{
            color: colorWhite,
          }}
          onClick={() => {
            onClickOK(description);
          }}
          disabled={false}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default RejectReasonModal;
